let goods = {
    data:[
       {
            id:10001,
            title:'Print Mesh Halter Ruched Maxi Dress',
            amount:'159.00',
            originalAmount:'',
            off:'',
            colors:[{name:'animal',src:require('../assets/color/animal.webp')}],
            sizes:[{size:'XS'},{size:'S'},{size:'M'},{size:'L'},{size:'XL',},],
            sku:'704898',
            categories:'new',
            categoryId:'10000',
            description:`Lightweight mesh drapes across the body with soft ruching and a halter neckline that draws focus upward and elongates the frame.`,
            key:`<ul><li>Halter Neck</li><li>Maxi Length</li><li>Mesh</li><li>Ruched</li><li>Sleeveless</li></ul>`,
            care:`<ul><li>95% Polyester 5% SpandexLining: 100% Polyester </li><li>Machine Wash Cold Separately in Laundry Bag. Gentle Cycle. Do not Bleach. Turn Inside Out. Gentle Cycle. Tumble Dry Low. Cool Iron if Needed. Dry Clean. </li><li>Imported</li></ul>`,
            images:[
                {src: require('../assets/10000/10001 (1).webp')},
                {src: require('../assets/10000/10001 (2).webp')},
                {src: require('../assets/10000/10001 (3).webp')},
          
            ],
        },
        {
            id:10002,
            title:'Sequin Crochet Ruffle Neck Gown',
            amount:'189.00',
            originalAmount:'',
            off:'',
            colors:[{name:'gold',src:require('../assets/color/gold.webp')}],
            sizes:[{size:'XS'},{size:'S'},{size:'M'},{size:'L'},{size:'XL',},],
            sku:'BEBE2247',
            categories:'new',
            categoryId:'10000',
            description:`Light-reflecting sequin crochet with a ruffled neckline builds subtle drama through texture and layered detail.`,
            key:`<ul><li>V-Neck</li><li>Ruffle Neck</li><li>Maxi Length</li><li>Crochet With Sequins</li><li>Sleeveless</li></ul>`,
            care:`<ul><li>100% PolyesterCombo: 100% Polyester</li><li>Machine Wash Cold with Like Colors. Do not Bleach. Tumble Dry Low. Remove Promptly. Cool Iron if Needed. Do not Dry Clean.</li><li>Imported</li></ul>`,
            images:[
                {src: require('../assets/10000/10002 (1).webp')},
                {src: require('../assets/10000/10002 (2).webp')},
                {src: require('../assets/10000/10002 (3).webp')},
            
            ],
        },
        {
            id:10003,
            title:'Fitted Linen Bustier',
            amount:'74.99',
            originalAmount:'100.00',
            off:'31',
            colors:[{name:'white alyssum',src:require('../assets/color/white.webp')}],
            sizes:[{size:'XS'},{size:'S'},{size:'M'},{size:'L'},{size:'XL',},],
            sku:'7SWT0485BE',
            categories:'new',
            categoryId:'10000',
            description:`A close-fitting linen bustier that hugs the body, highlighting the waist while keeping things breathable and unfussy.`,
            key:`<ul><li>Corset Illusion</li><li> Shirring Fitted</li><li> Linen Bustier</li><li> Gold Metal Hardware</li><li> 18" Top Length</li></ul>`,
            care:`<ul><li>70% Rayon, 30% Linen;Lining: 100% Cotton</li><li>Hand Wash, Hang To Dry</li><li>Imported</li></ul>`,
            images:[
                {src: require('../assets/10000/10003 (1).webp')},
                {src: require('../assets/10000/10003 (2).webp')},
                {src: require('../assets/10000/10003 (3).webp')},
                {src: require('../assets/10000/10003 (4).webp')},
                {src: require('../assets/10000/10003 (5).webp')},
            
            ],
        },
        {
            id:10004,
            title:'Linen Palazzo Pants',
            amount:'94.99',
            originalAmount:'139.00',
            off:'31',
            colors:[{name:'white alyssum',src:require('../assets/color/white.webp')}],
            sizes:[{size:'XS'},{size:'S'},{size:'M'},{size:'L'},{size:'XL',},],
            sku:'7SWP0420BE',
            categories:'new',
            categoryId:'10000',
            description:`Wide-leg linen pants with a relaxed drape, made for staying cool while still looking intentionally styled.`,
            key:`<ul><li>Wide Leg</li><li> Front Pocket</li><li> Gold Metal Hardware</li><li> Linen Pant</li><li>32" Bottom Inseam</li></ul>`,
            care:`<ul><li>70% Rayon, 30% Linen;Lining: 100% Cotton</li><li>Hand Wash, Hang To Dry</li><li>Imported</li></ul>`,
            images:[
                {src: require('../assets/10000/10004 (1).webp')},
                {src: require('../assets/10000/10004 (2).webp')},
                {src: require('../assets/10000/10004 (3).webp')},
                {src: require('../assets/10000/10004 (4).webp')},
            
            ],
        },
        {
            id:10005,
            title:'Floral Applique Crochet Maxi Dress',
            amount:'169.00',
            originalAmount:'',
            off:'',
            colors:[{name:'shell',src:require('../assets/color/shell.webp')}],
            sizes:[{size:'XS'},{size:'S'},{size:'M'},{size:'L'},{size:'XL',},],
            sku:'7SWP0421BE',
            categories:'new',
            categoryId:'10000',
            description:`Crochet texture meets dimensional floral details, creating depth and movement throughout a full-length, softly draped silhouette.`,
            key:`<ul><li>V-Neck</li><li>Sleeveless</li><li>Maxi Length</li><li>Floral Applique </li><li>Sleeveless</li></ul>`,
            care:`<ul><li>51% Viscose 27% Polyester 22% Polyamide</li><li>Hand Wash Cold Separately. Do not Bleach. Turn Inside Out and Gentle Cycle. Dry Flat. Cool Iron if Needed. Dry Clean.</li><li>Imported</li></ul>`,
            images:[
                {src: require('../assets/10000/10005 (1).webp')},
                {src: require('../assets/10000/10005 (2).webp')},
                {src: require('../assets/10000/10005 (3).webp')},
                {src: require('../assets/10000/10005 (4).webp')},
              
            ],
        },
        {
            id:10006,
            title:'Lace Keyhhole Long Sleeve Midi Dress',
            amount:'169.00',
            originalAmount:'',
            off:'',
            colors:[{name:'nude white',src:require('../assets/color/white-nude.webp')}],
            sizes:[{size:'XS'},{size:'S'},{size:'M'},{size:'L'},{size:'XL',},],
            sku:'8010409',
            categories:'new',
            categoryId:'10000',
            description:`Intricate lace layered with a keyhole opening creates quiet balance between coverage and reveal throughout the entire silhouette.`,
            key:`<ul><li>Long Sleeve</li><li>Midi Length</li><li>Lace</li><li>Keyhole At Chest</li><li>Long Sleeve</li></ul>`,
            care:`<ul><li>95% Nylon 5% SpandexLining: 95% Polyester 5% Spandex</li><li>Machine Wash Cold with Like Colors. Do not Bleach. Tumble Dry Low. Remove Promptly. Cool Iron if Needed. Do not Dry Clean.</li><li>Made in USA</li></ul>`,
            images:[
                {src: require('../assets/10000/10006 (1).webp')},
                {src: require('../assets/10000/10006 (2).webp')},
                {src: require('../assets/10000/10006 (3).webp')},
               
            ],
        },
        {
            id:10007,
            title:'Resort Crochet Knit Top',
            amount:'109.00',
            originalAmount:'',
            off:'',
            colors:[{name:'sundust',src:require('../assets/color/sundust-ws.webp')}],
            sizes:[{size:'XS'},{size:'S'},{size:'M'},{size:'L'},{size:'XL',},],
            sku:'7SKW0290BE',
            categories:'new',
            categoryId:'10000',
            description:`An open crochet knit that shows just enough skin.`,
            key:`<ul><li>Cropped Fitted Silhouette</li><li> Long Flared Sleeve</li><li> Gold Trim</li><li> Soft Yarn</li><li> 16" Top Length</li></ul>`,
            care:`<ul><li>72% Viscose, 28% Polyester</li><li>Hand Wash, Lay Flat To Dry</li><li>Imported</li></ul>`,
            images:[
                {src: require('../assets/10000/10007 (1).webp')},
                {src: require('../assets/10000/10007 (2).webp')},
                {src: require('../assets/10000/10007 (3).webp')},
                {src: require('../assets/10000/10007 (4).webp')},
                
            ],
        },
        {
            id:10008,
            title:'High Waisted Cutout Linen Jogger',
            amount:'81.99',
            originalAmount:'119.00',
            off:'31',
            colors:[{name:'sundust',src:require('../assets/color/sundust.webp')}],
            sizes:[{size:'XS'},{size:'S'},{size:'M'},{size:'L'},{size:'XL',},],
            sku:'7SWP0419BE',
            categories:'new',
            categoryId:'10000',
            description:`Relaxed linen joggers with cutout details and a high waist, mixing casual comfort with a bold, modern twist.`,
            key:`<ul><li>Two Elasticated Waistband</li><li> Linen Jogger</li><li>29" Bottom Inseam</li></ul>`,
            care:`<ul><li>70% Rayon, 30% Linen</li><li>Hand Wash, Hang To Dry</li><li>Imported</li></ul>`,
            images:[
                {src: require('../assets/10000/10008 (1).webp')},
                {src: require('../assets/10000/10008 (2).webp')},
                {src: require('../assets/10000/10008 (3).webp')},
                {src: require('../assets/10000/10008 (4).webp')},
               
            ],
        },
        {
            id:10009,
            title:'V-Neck Strap Bandage Dress',
            amount:'169.00',
            originalAmount:'',
            off:'',
            colors:[{name:'olive',src:require('../assets/color/olive.webp')}],
            sizes:[{size:'XS'},{size:'S'},{size:'M'},{size:'L'},{size:'XL',},],
            sku:'BEBE2049',
            categories:'new',
            categoryId:'10000',
            description:`A fitted pencil dress that highlights your shape while keeping things timeless and versatile.`,
            key:`<ul><li>V-Neck</li><li>Bodycon Dress</li><li>Sleeveless</li></ul>`,
            care:`<ul><li>96% Polyester 4% Elastane</li><li>Machine Wash Cold Gentle CycleInside Out. Only Non-Chlorine Bleach when Needed. Tumble Dry Low. Warm Iron if Needed. Dry Clean.</li><li>Imported</li></ul>`,
            images:[
                {src: require('../assets/10000/10009 (1).webp')},
                {src: require('../assets/10000/10009 (2).webp')},
                {src: require('../assets/10000/10009 (3).webp')},
                {src: require('../assets/10000/10009 (4).webp')},
             
            ],
        },
        {
            id:10010,
            title:'Foiled Bandage V Neck Midi Dress',
            amount:'189.00',
            originalAmount:'',
            off:'',
            colors:[{name:'wine',src:require('../assets/color/wine.webp')}],
            sizes:[{size:'XS'},{size:'S'},{size:'M'},{size:'L'},{size:'XL',},],
            sku:'SALT1819',
            categories:'new',
            categoryId:'10000',
            description:`A knee-length bodycon dress with a flattering V-neckline that's always ready for a night out.`,
            key:`<ul><li>V-Neck</li><li>Sleeveless</li><li>Bodycon</li><li>Knee Length </li><li>Sleeveless</li></ul>`,
            care:`<ul><li>96% Polyester 4% Elastane</li><li>Hand Wash Cold Separately, Do not Bleach, Turn Inside Out and Gentle Cycle, Tumble Dry Low, Cool Iron if needed, Dry Clean</li><li>Imported</li></ul>`,
            images:[
                {src: require('../assets/10000/10010 (1).webp')},
                {src: require('../assets/10000/10010 (2).webp')},
                {src: require('../assets/10000/10010 (3).webp')},
                {src: require('../assets/10000/10010 (4).webp')},
           
            ],
        },
        {
            id:10011,
            title:'Bandage Halter Dress',
            amount:'189.00',
            originalAmount:'',
            off:'',
            colors:[{name:'silver',src:require('../assets/color/silver.webp')}],
            sizes:[{size:'XS'},{size:'S'},{size:'M'},{size:'L'},{size:'XL',},],
            sku:'SALT1651',
            categories:'new',
            categoryId:'10000',
            description:`A halter midi silhouette with a figure-flattering fit and just the right amount of confidence.`,
            key:`<ul><li>Halter Neck</li><li>Midi Length</li><li>Bodycon</li><li>Sleeveless</li></ul>`,
            care:``,
            images:[
                {src: require('../assets/10000/10011 (1).webp')},
                {src: require('../assets/10000/10011 (2).webp')},
                {src: require('../assets/10000/10011 (3).webp')},
                {src: require('../assets/10000/10011 (4).webp')},
       
            ],
        },
        {
            id:10012,
            title:'NATURAL WAIST GOLD DETAIL LEGGING',
            amount:'119.00',
            originalAmount:'',
            off:'',
            colors:[{name:'black',src:require('../assets/color/black.webp')}],
            sizes:[{size:'XS'},{size:'S'},{size:'M'},{size:'L'},{size:'XL',},],
            sku:'7SKP0421BE',
            categories:'new',
            categoryId:'10000',
            description:`A curve-hugging legging with gold-tone details that does all the heavy lifting for your outfit.`,
            key:`<ul><li>Soft Stretch Fabric </li><li>Cut Seam Details </li><li>Gold Snaps </li><li>Side Panels</li><li>   Top Length</li><li> 28" Bottom Inseam</li></ul>`,
            care:`<ul><li>67% Rayon, 28% Nylon, 5% Spandex</li><li>Hand Wash, Hang To Dry</li><li>Imported</li></ul>`,
            images:[
                {src: require('../assets/10000/10012 (1).webp')},
                {src: require('../assets/10000/10012 (2).webp')},
                {src: require('../assets/10000/10012 (3).webp')},
                {src: require('../assets/10000/10012 (4).webp')},
      
            ],
        },
        {
            id:10013,
            title:'MOTOR BIKE JACKET',
            amount:'169.00',
            originalAmount:'',
            off:'',
            colors:[{name:'black',src:require('../assets/color/black.webp')}],
            sizes:[{size:'XS'},{size:'S'},{size:'M'},{size:'L'},{size:'XL',},],
            sku:'7SKJ0255BE',
            categories:'new',
            categoryId:'10000',
            description:`A moto jacket that adds an effortless cool factor to every outfit in your closet.`,
            key:`<ul><li>Stretch Vegan Leather Mixed With Stretch Knit Rib </li><li>Mock Neck </li><li>Zipper Opening </li><li>Belt Detail</li><li> 20" Top Length</li></ul>`,
            care:`<ul><li>100% Polyurethane;RIB Combo: 96% Polyester, 4% Spandex;Lining: 98% Polyester, 2% Spandex</li><li>Hand Wash, Hang To Dry</li><li>Imported</li></ul>`,
            images:[
                {src: require('../assets/10000/10013 (1).webp')},
                {src: require('../assets/10000/10013 (2).webp')},
                {src: require('../assets/10000/10013 (3).webp')},
                {src: require('../assets/10000/10013 (4).webp')},
          
            ],
        },
        {
            id:10014,
            title:'Faux Leather Midi Pencil Dress',
            amount:'189.00',
            originalAmount:'',
            off:'',
            colors:[{name:'wine',src:require('../assets/color/wine-ws.webp')}],
            sizes:[{size:'XS'},{size:'S'},{size:'M'},{size:'L'},{size:'XL',},],
            sku:'BEBE1907',
            categories:'new',
            categoryId:'10000',
            description:`A floral mini dress covered in dimensional blooms and made for birthdays, brunches, and everything after.`,
            key:`<ul><li>Pencil Dress</li><li>Sleeveless</li><li>Crew Neck </li><li>Sleeveless</li></ul>`,
            care:`<ul><li>100% Polyester</li><li>Wipe Clean with a Damp Cloth, Do not Machine Wash, Do not Bleach, Line Dry, Do not Tumble Dry, Do not Iron, Keep Away from Fire, Do not Dry Clean </li><li>Imported</li></ul>`,
            images:[
                {src: require('../assets/10000/10014 (1).webp')},
                {src: require('../assets/10000/10014 (2).webp')},
                {src: require('../assets/10000/10014 (3).webp')},
                {src: require('../assets/10000/10014 (4).webp')},
          
            ],
        },
        {
            id:10015,
            title:'3D Floral Fit & Flare Mini Dress',
            amount:'239.00',
            originalAmount:'',
            off:'',
            colors:[{name:'black/brown',src:require('../assets/color/black_brown.webp')}],
            sizes:[{size:'XS'},{size:'S'},{size:'M'},{size:'L'},{size:'XL',},],
            sku:'BEBE1363',
            categories:'new',
            categoryId:'10000',
            description:`A one-shoulder jumpsuit with illusion details that creates a striking look from every angle.`,
            key:`<ul><li>Short Sleeves</li><li>Mini Length</li><li>Crew Neck</li><li>3D Floral</li><li>Short Sleeve</li></ul>`,
            care:`<ul><li>100% Polyester</li><li>Hand Wash Cold Separately, Do not Bleach, Turn Inside Out and Gentle Cycle, Tumble Dry Low, Cool Iron if needed, Dry Clean</li><li>Imported</li></ul>`,
            images:[
                {src: require('../assets/10000/10015 (1).webp')},
                {src: require('../assets/10000/10015 (2).webp')},
                {src: require('../assets/10000/10015 (3).webp')},
                {src: require('../assets/10000/10015 (4).webp')},
            
            ],
        },
        {
            id:10016,
            title:'NIGHT OUT FITTED CATSUIT',
            amount:'169.00',
            originalAmount:'',
            off:'',
            colors:[{name:'black',src:require('../assets/color/black.webp')}],
            sizes:[{size:'XS'},{size:'S'},{size:'M'},{size:'L'},{size:'XL',},],
            sku:'7SKG0205BE',
            categories:'new',
            categoryId:'10000',
            description:`A fitted catsuit designed for nights when blending in isn't part of the plan.`,
            key:`<ul><li>Soft Stretch Fabric </li><li>Faux Cut-Out Detail At The Waist </li><li>Back Zipper Opening </li><li>Pu Flat Piping</li><li>   Top Length</li><li> 28" Bottom Inseam</li></ul>`,
            care:`<ul><li>67% Rayon, 28% Nylon, 5% Spandex;Mesh Combo: 94% Nylon, 6% Spandex</li><li>Hand Wash, Hang To Dry</li><li>Imported</li></ul>`,
            images:[
                {src: require('../assets/10000/10016 (1).webp')},
                {src: require('../assets/10000/10016 (2).webp')},
                {src: require('../assets/10000/10016 (3).webp')},
                {src: require('../assets/10000/10016 (4).webp')},
              
            ],
        },
        {
            id:10017,
            title:'LOW WAIST SHIRRED LEATHER LEGGING',
            amount:'129.00',
            originalAmount:'',
            off:'',
            colors:[{name:'black',src:require('../assets/color/black.webp')}],
            sizes:[{size:'XS'},{size:'S'},{size:'M'},{size:'L'},{size:'XL',},],
            sku:'7SKG0215BE',
            categories:'new',
            categoryId:'10000',
            description:`A low-rise vegan leather legging with a flattering fit and serious going-out energy.`,
            key:`<ul><li>Soft Stretch Fabric Mixed With Stretch Vegan Leather </li><li>Shirring Along Cut Seams </li><li>Pull-On Style</li><li>   Top Length</li><li> 28" Bottom Inseam</li></ul>`,
            care:`<ul><li>67% Rayon, 28% Nylon, 5% Spandex;VEGAN LEATHER Combo: 100% Polyurethane</li><li>Hand Wash, Hang To Dry</li><li>Imported</li></ul>`,
            images:[
                {src: require('../assets/10000/10017 (1).webp')},
                {src: require('../assets/10000/10017 (2).webp')},
                {src: require('../assets/10000/10017 (3).webp')},
                {src: require('../assets/10000/10017 (4).webp')},
            
            ],
        },
        {
            id:10018,
            title:'SHEER BUBBLE BLOUSE',
            amount:'129.00',
            originalAmount:'',
            off:'',
            colors:[{name:'sage green',src:require('../assets/color/sage_green_sw.jpg')}],
            sizes:[{size:'XS'},{size:'S'},{size:'M'},{size:'L'},{size:'XL',},],
            sku:'7SKL0245BE',
            categories:'new',
            categoryId:'10000',
            description:`A sheer bubble blouse that brings volume, drama, and just the right amount of attention.`,
            key:`<ul><li>Soft Sheer Stretch Fabric </li><li>Cropped Length With Blouson </li><li>Gold Buttons With Rhinestones </li><li>Raglan Sleeve</li><li> 19" Top Length</li></ul>`,
            care:`<ul><li>100% Polyester</li><li>Hand Wash, Hang To Dry</li><li>Imported</li></ul>`,
            images:[
                {src: require('../assets/10000/10018 (1).webp')},
                {src: require('../assets/10000/10018 (2).webp')},
                {src: require('../assets/10000/10018 (3).webp')},
                {src: require('../assets/10000/10018 (4).webp')},
            
            ],
        },
        {
            id:10019,
            title:'OFF SHOULDER CHARMED TOP',
            amount:'98.00',
            originalAmount:'',
            off:'',
            colors:[{name:'black',src:require('../assets/color/black.webp')}],
            sizes:[{size:'XS'},{size:'S'},{size:'M'},{size:'L'},{size:'XL',},],
            sku:'7SKT0490BE',
            categories:'new',
            categoryId:'10000',
            description:`An off-the-shoulder top with eye-catching details that was made for compliments and late-night plans.`,
            key:`<ul><li>Soft Stretch Fabric</li><li>Fitted Silhouette</li><li>Gold Chain With Bebe Charms</li><li>Off-The-Shoulder With Mesh</li><li> 19" Top Length</li></ul>`,
            care:`<ul><li>85% Nylon, 15% Spandex;Mesh Combo: 94% Nylon, 6% Spandex;Lining: 95% Polyester, 5% Spandex</li><li>Hand Wash, Hang To Dry</li><li>Imported</li></ul>`,
            images:[
                {src: require('../assets/10000/10019 (1).webp')},
                {src: require('../assets/10000/10019 (2).webp')},
                {src: require('../assets/10000/10019 (3).webp')},
                {src: require('../assets/10000/10019 (4).webp')},
                {src: require('../assets/10000/10019 (5).webp')},
       
            ],
        },
        {
            id:10020,
            title:'Lace Illusion Strapless Midi Dress',
            amount:'139.00',
            originalAmount:'',
            off:'',
            colors:[{name:'black',src:require('../assets/color/black.webp')}],
            sizes:[{size:'XS'},{size:'S'},{size:'M'},{size:'L'},{size:'XL',},],
            sku:'7SKT0497BE',
            categories:'new',
            categoryId:'10000',
            description:`A strapless lace silhouette that feels effortlessly feminine with just the right amount of attention-grabbing detail.`,
            key:`<ul><li>Strapless</li><li>Knee Length</li><li>Illusion Lace </li><li>Sleeveless</li></ul>`,
            care:`<ul><li>55% Polyamide 45% CottonLining: 100% Polyester</li><li>Hand Wash Cold. Turn Inside Out. Do not Bleach. Dry Flat. Cool Iron if Needed on Reverse Side. Do not Dry Clean. </li><li>Made in USA</li></ul>`,
            images:[
                {src: require('../assets/10000/10020 (1).webp')},
                {src: require('../assets/10000/10020 (2).webp')},
                {src: require('../assets/10000/10020 (3).webp')},
                {src: require('../assets/10000/10020 (4).webp')},
                
            ],
        },
       
        {
            id:20001,
            title:'Bandage Midi Dress',
            amount:'159.00',
            originalAmount:'',
            off:'',
            colors:[{name:'white',src:require('../assets/color/white.webp')}],
            sizes:[{size:'XXS'},{size:'XS'},{size:'S'},{size:'M'},{size:'L'},{size:'XL'},{size:'XXL'},],
            sku:'SALT022',
            categories:'dresses',
            categoryId:'20000',
            description:`A V-neck midi silhouette with a figure-flattering fit and just the right amount of confidence.`,
            key:`<ul><li>V-Neck</li><li>Midi Length</li><li>Bodycon</li><li>Sleeveless</li></ul>`,
            care:`<ul><li>96% Polyester 4% Elastane</li><li>Machine Wash Cold Gentle Cycle Inside Out. Only Non-Chlorine Bleach with Needed. Tumble Dry Low. Warm Iron if Needed. Dry Clean.</li><li>Imported</li></ul>`,
            images:[
                {src: require('../assets/20000/20001 (1).webp')},
                {src: require('../assets/20000/20001 (2).webp')},
                {src: require('../assets/20000/20001 (3).webp')},
            
            ],
        },
       {
            id:20002,
            title:'Polka Dot Mesh Shirred Halter Dress',
            amount:'149.00',
            originalAmount:'',
            off:'',
            colors:[{name:'brown white',src:require('../assets/color/brown_white.webp')}],
            sizes:[{size:'XS'},{size:'S'},{size:'M'},{size:'L'},{size:'XL',},],
            sku:'705167',
            categories:'dresses',
            categoryId:'20000',
            description:`Sheer mesh layered with a playful print, shaped through shirring that hugs in all the right places without feeling restrictive.`,
            key:`<ul><li>Halter Neck</li><li>Mesh</li><li>Midi Length </li><li>Sleeveless</li></ul>`,
            care:`<ul><li>97% Polyester 3% SpandexLining: 95% Polyester 5% Spandex</li><li>Machine Wash Cold with Like Colors. Do not Bleach. Tumble Dry Low. Remove Promptly. Cool Iron if Needed. Do not Dry Clean.</li><li>Made in USA</li></ul>`,
            images:[
                {src: require('../assets/20000/20002 (1).webp')},
                {src: require('../assets/20000/20002 (2).webp')},
                {src: require('../assets/20000/20002 (3).webp')},
                {src: require('../assets/20000/20002 (4).webp')},
            
            ],
        },
        {
            id:20003,
            title:'Lace Drop Waist Maxi Dress',
            amount:'159.00',
            originalAmount:'',
            off:'',
            colors:[{name:'rose',src:require('../assets/color/pink.webp')}],
            sizes:[{size:'XS'},{size:'S'},{size:'M'},{size:'L'},{size:'XL',},],
            sku:'8010418',
            categories:'dresses',
            categoryId:'20000',
            description:`A drop waist and lace construction create a relaxed yet striking profile, ideal for creative events and dinners with a fashion‑forward crowd.`,
            key:`<ul><li>Square Neckline</li><li>Sleeveless</li><li>Midi Length</li><li>Sleeveless</li></ul>`,
            care:`<ul><li>95% Nylon 5% SpandexLining: 95% Polyester 5% Spandex</li><li>Machine Wash Cold with Like Colors. Do not Bleach. Tumble Dry Low. Remove Promptly. Cool Iron if Needed. Do not Dry Clean. </li><li>Made in USA</li></ul>`,
            images:[
                {src: require('../assets/20000/20003 (1).webp')},
                {src: require('../assets/20000/20003 (2).webp')},
                {src: require('../assets/20000/20003 (3).webp')},
                {src: require('../assets/20000/20003 (4).webp')},
              
            ],
        },
        {
            id:20004,
            title:'V-Neck Ruched Mesh Flounce Midi Dress',
            amount:'189.00',
            originalAmount:'',
            off:'',
            colors:[{name:'red',src:require('../assets/color/red.webp')}],
            sizes:[{size:'XS'},{size:'S'},{size:'M'},{size:'L'},{size:'XL',},],
            sku:'BEBE1381',
            categories:'dresses',
            categoryId:'20000',
            description:`Ruching and mesh that move effortlessly with every step.`,
            key:`<ul><li>V-Neck</li><li>Bodycon</li><li>Ruched Front</li><li>Mesh</li><li>Sleeveless</li></ul>`,
            care:`<ul><li>95% Polyester 5% SpandexLining: 100% Polyester</li><li>Machine Wash Cold Separately. Gentle Cycle. Do not Bleach.Hang to Dry in Shade. Do not Tumble Dry or Twist. Cool Iron if Needed. Do not Dry Clean.</li><li>Imported</li></ul>`,
            images:[
                {src: require('../assets/20000/20004 (1).webp')},
                {src: require('../assets/20000/20004 (2).webp')},
                {src: require('../assets/20000/20004 (3).webp')},
                {src: require('../assets/20000/20004 (4).webp')},
    
            ],
        },
        {
            id:20005,
            title:'Bold Blazer Dress',
            amount:'179.00',
            originalAmount:'',
            off:'',
            colors:[{name:'black',src:require('../assets/color/black.webp')}],
            sizes:[{size:'XS'},{size:'S'},{size:'M'},{size:'L'},{size:'XL',},],
            sku:'BEBE1262',
            categories:'dresses',
            categoryId:'20000',
            description:`Command the room in the Bebe X Ciara Bold Blazer Dress. Tailored to speak volumes, this dress merges power and allure, perfectly mirroring Ciara’s hit ‘I’m Out.’ Whether leading a meeting or stepping out for a night on the town, slip into this piece and prepare to turn heads and break hearts in ultimate diva fashion.`,
            key:`<ul><li>Self: 95% Polyester 5% Elastane Lining: 100% Polyester</li><li>Dry clean only</li><li>Imported</li><li>33 1/2" from Shoulder</li></ul>`,
            care:``,
            images:[
                {src: require('../assets/20000/20005 (1).webp')},
                {src: require('../assets/20000/20005 (2).webp')},
                {src: require('../assets/20000/20005 (3).webp')},
                {src: require('../assets/20000/20005 (4).webp')},
            
            ],
        },
        {
            id:20006,
            title:'Twist Back Boatneck Gown',
            amount:'189.00',
            originalAmount:'',
            off:'',
            colors:[{name:'rose',src:require('../assets/color/rose.webp')}],
            sizes:[{size:'XS'},{size:'S'},{size:'M'},{size:'L'},{size:'XL',},],
            sku:'8010490',
            categories:'dresses',
            categoryId:'20000',
            description:`An ankle-length dress with a dramatic twist-back design that guarantees compliments from every angle.`,
            key:`<ul><li>Ankle Length</li><li>Twist Back</li><li>Boat Neck</li><li>Sleeveless</li></ul>`,
            care:`<ul><li>95% Polyester 5% SpandexLining: 95% Polyester 5% Spandex</li><li>Machine Wash Cold with Like Colors. Do not Bleach. Tumble Dry Low. Remove Promptly. Cool Iron if Needed. Do not Dry Clean. </li><li>Imported</li></ul>`,
            images:[
                {src: require('../assets/20000/20006 (1).webp')},
                {src: require('../assets/20000/20006 (2).webp')},
                {src: require('../assets/20000/20006 (3).webp')},
                {src: require('../assets/20000/20006 (4).webp')},
      
            ],
        },
        {
            id:20007,
            title:'Crochet Tank Sweater Dress',
            amount:'189.00',
            originalAmount:'',
            off:'',
            colors:[{name:'sand',src:require('../assets/color/sand.webp')}],
            sizes:[{size:'XS'},{size:'S'},{size:'M'},{size:'L'},{size:'XL',},],
            sku:'107479',
            categories:'dresses',
            categoryId:'20000',
            description:`Open crochet texture and a tank silhouette create an effortless look for warm evenings, beachside dinners, or casual gatherings with a relaxed feel.`,
            key:`<ul><li>Crew Neck</li><li>Sleeveless</li><li>Fringe Skirt</li><li>Midi Length<br></li></ul>`,
            care:`<ul><li>96% Polyester 4% Elastane</li><li>Machine Wash Cold Gentle Cycle Inside Out. Only Non-Chlorine Bleach when Needed. Tumble Dry Low. Warm Iron if Needed. Dry Clean.</li><li>Imported</li></ul>`,
            images:[
                {src: require('../assets/20000/20007 (1).webp')},
                {src: require('../assets/20000/20007 (2).webp')},
                {src: require('../assets/20000/20007 (3).webp')},
                {src: require('../assets/20000/20007 (4).webp')},
                
            ],
        },
        {
            id:20008,
            title:'Tiered Satin High Low Gown',
            amount:'144.99 ',
            originalAmount:'208.00 ',
            off:'30',
            colors:[{name:'white',src:require('../assets/color/white.webp')}],
            sizes:[{size:'XS'},{size:'S'},{size:'M'},{size:'L'},{size:'XL',},],
            sku:'BEBE1388',
            categories:'dresses',
            categoryId:'20000',
            description:`Turn heads in this romantic midi dress, boasting a high-low ruffle hem and elegant sash tie—your plus-one for weddings and garden parties.`,
            key:`<ul><li>Bias Cut</li><li>Fully Lined</li><li>Adjustable Straps - Cross at back</li><li>Zipper closure at back waist</li><li>High Low Ruffle Hemline</li><li>Sash can be worn tied front or back</li><li>Perfect for Wedding Season</li><li>Sleeveless</li></ul>`,
            care:`<ul><li>100% Polyester, Lining 100% Polyester</li><li>Machine Wash Cold With Like Colors. Do Not Bleach. Tumble Dry Low. Remove Promptly. Cool Iron If Needed. Do Not Dry Clean.</li><li>Imported</li></ul>`,
            images:[
                {src: require('../assets/20000/20008 (1).webp')},
                {src: require('../assets/20000/20008 (2).webp')},
                {src: require('../assets/20000/20008 (3).webp')},
                {src: require('../assets/20000/20008 (4).webp')},
         
            ],
        },
        {
            id:20009,
            title:'Rhinestone Trim Jersey Short Dress',
            amount:'67.99',
            originalAmount:'98.00',
            off:'30',
            colors:[{name:'black',src:require('../assets/color/black.webp')}],
            sizes:[{size:'XS'},{size:'S'},{size:'M'},{size:'L'},{size:'XL',},],
            sku:'704190',
            categories:'dresses',
            categoryId:'20000',
            description:`Turn up the heat in our Rhinestone Trim Jersey Short Dress. This style guarantees you're the center of attention with its shimmering accents and body-hugging silhouette.`,
            key:`<ul><li>Jersey Short Dress</li><li>Rhinestone Trim at the Front Neck</li><li>Satin Adjustable Straps</li><li>Coverstitch Hem</li><li>Sleeveless</li></ul>`,
            care:`<ul><li>95% Poly 5% Span</li><li>Hand Wash Cold With Like Color, Do Not Bleach, Line Dry, Cool Iron If Needed, Do Not Dry Clean</li><li>Imported</li></ul>`,
            images:[
                {src: require('../assets/20000/20009 (1).webp')},
                {src: require('../assets/20000/20009 (2).webp')},
                {src: require('../assets/20000/20009 (3).webp')},
                {src: require('../assets/20000/20009 (4).webp')},
              
            ],
        },
        {
            id:20010,
            title:'Striple Long Sleeve Slim Dress',
            amount:'159.00',
            originalAmount:'',
            off:'',
            colors:[{name:'multi',src:require('../assets/color/multi.webp')}],
            sizes:[{size:'XS'},{size:'S'},{size:'M'},{size:'L'},{size:'XL',},],
            sku:'BEBE3007',
            categories:'dresses',
            categoryId:'20000',
            description:`Long sleeves, striped pattern, and a slim fit that looks sharp instantly. Wear it to dinners, daytime events, and nights you want sleek without trying.`,
            key:`<ul><li>Long Sleeve</li><li>Mini Length</li><li>Boat Neck</li><li>Multi Colored Stripes<br></li></ul>`,
            care:`<ul><li>Shell: 65% Polyester 35% Cotton Lining: 100% Polyester</li><li>Machine Wash Cold Separately in Laundry Bags. Gentle Cycle. Do not Bleach. Do not Tumble Dry or Twist. Dry Flat in Shade. Cool Iron if Needed. Dry Clean.</li><li>Imported</li></ul>`,
            images:[
                {src: require('../assets/20000/20010 (1).webp')},
                {src: require('../assets/20000/20010 (2).webp')},
                {src: require('../assets/20000/20010 (3).webp')},
                {src: require('../assets/20000/20010 (4).webp')},
         
            ],
        },
        {
            id:20011,
            title:'One Shoulder Trim Strap Midi Dress',
            amount:'103.99',
            originalAmount:'149.00',
            off:'30',
            colors:[{name:'olive',src:require('../assets/color/olive.webp')}],
            sizes:[{size:'XS'},{size:'S'},{size:'M'},{size:'L'},{size:'XL',},],
            sku:'BEBE2271',
            categories:'dresses',
            categoryId:'20000',
            description:`One-shoulder silhouette with a sleek trim strap detail. Wear this midi to cocktail events, rehearsal dinners, and nights you want clean lines and bold energy.`,
            key:`<ul><li>One Shoulder</li><li>Midi Length</li><li>Bodycon </li><li>Sleeveless</li></ul>`,
            care:`<ul><li>95% Polyester 5% Spandex</li><li>Machine Wash Cold with like Colors. Do not Bleach. Tumble Dry Low. Do not Dry Clean. </li><li>Made in USA</li></ul>`,
            images:[
                {src: require('../assets/20000/20011 (1).webp')},
                {src: require('../assets/20000/20011 (2).webp')},
                {src: require('../assets/20000/20011 (3).webp')},
                {src: require('../assets/20000/20011 (4).webp')},
            
            ],
        },
        {
            id:20012,
            title:'Lace Bustier Midi Dress',
            amount:'179.00',
            originalAmount:'',
            off:'',
            colors:[{name:'black/nude',src:require('../assets/color/black.webp')}],
            sizes:[{size:'XS'},{size:'S'},{size:'M'},{size:'L'},{size:'XL',},],
            sku:'BEBE2198',
            categories:'dresses',
            categoryId:'20000',
            description:`Lace bustier detail with a midi length that plays sweet, kind of. Wear it to date night, bridal events, and cocktail parties where you want attention, politely.`,
            key:`<ul><li>Sweetheart Neckline</li><li>Sleeveless</li><li>Ankle Length </li><li>Sleeveless</li></ul>`,
            care:`<ul><li>Shell 1: 95% Nylon 5% SpandexShell 2: 96% Polyester 4% SpandexLining: 100% Polyester </li><li>Machine Wash Cold Separately in Laundry Bags. Gentle Cycle. Do not Bleach. Do not Tumble Dry or Twist. Dry Flat in shade. Cool Iron if Needed. Dry Clean. </li><li>Imported</li></ul>`,
            images:[
                {src: require('../assets/20000/20012 (1).webp')},
                {src: require('../assets/20000/20012 (2).webp')},
                {src: require('../assets/20000/20012 (3).webp')},
                {src: require('../assets/20000/20012 (4).webp')},
          
            ],
        },
        {
            id:20013,
            title:'Printed Chiffon Tie Front Maxi Dress',
            amount:'124.99',
            originalAmount:'179.00',
            off:'30',
            colors:[{name:'chocolate',src:require('../assets/color/chocolate.webp')}],
            sizes:[{size:'XS'},{size:'S'},{size:'M'},{size:'L'},{size:'XL',},],
            sku:'704656',
            categories:'dresses',
            categoryId:'20000',
            description:`Featherlight printed chiffon with a flirty tie-front detail and a sweeping maxi hem. Perfect for beachside dinners, winery weekends, and vacation flirting.`,
            key:`<ul><li>Long Sleeve</li><li>Maxi Length</li><li>Tie Front<br></li></ul>`,
            care:`<ul><li>Shell: 100% Polyester Lining: 100% Polyester</li><li>Machine Wash Cold with Like Colors. Do not Bleach. Tumble Dry Low. Jhang to Dry in Shade. Cool Iron if Needed. Dry Clean.</li><li>Imported</li></ul>`,
            images:[
                {src: require('../assets/20000/20013 (1).webp')},
                {src: require('../assets/20000/20013 (2).webp')},
                {src: require('../assets/20000/20013 (3).webp')},
                {src: require('../assets/20000/20013 (4).webp')},
            
            ],
        },
        {
            id:20014,
            title:'Printed Chiffon Halter Ruffle Dress',
            amount:'110.99',
            originalAmount:'159.00',
            off:'30',
            colors:[{name:'blue floral',src:require('../assets/color/blue_floral.webp')}],
            sizes:[{size:'XS'},{size:'S'},{size:'M'},{size:'L'},{size:'XL',},],
            sku:'704659',
            categories:'dresses',
            categoryId:'20000',
            description:`Airy chiffon, halter neckline, and ruffles that do the flirting for you. Wear it to garden parties, brunch plans, and vacation dinners with a warm breeze.`,
            key:`<ul><li>Halter Tneck</li><li>Sleeveless</li><li>Maxi Length</li><li>Ruffle Skirt</li><li>Sleeveless</li></ul>`,
            care:`<ul><li>Shell: 100% Polyester Lining: 100% Polyester</li><li>Machine Wash Cold with Like Colors. Do not Bleach. Tumble Dry Low. Hang to Dry in Shade. Cool Iron if Needed. Dry Clean. </li><li>Imported</li></ul>`,
            images:[
                {src: require('../assets/20000/20014 (1).webp')},
                {src: require('../assets/20000/20014 (2).webp')},
                {src: require('../assets/20000/20014 (3).webp')},
                {src: require('../assets/20000/20014 (4).webp')},
            
            ],
        },
        {
            id:20015,
            title:'Strapless Cascade Midi Dress',
            amount:'198.00',
            originalAmount:'',
            off:'',
            colors:[{name:'black',src:require('../assets/color/black.webp')}],
            sizes:[{size:'XS'},{size:'S'},{size:'M'},{size:'L'},{size:'XL',},],
            sku:'BEBE2238',
            categories:'dresses',
            categoryId:'20000',
            description:`Strapless neckline with cascading layers that move when you do. Wear it to cocktail parties, wedding receptions, and nights that start with “let’s go out.”`,
            key:`<ul><li>Strapless</li><li>Midi Length</li><li>Sleeveless</li></ul>`,
            care:`<ul><li>Self: 97% Polyester 3% SpandexLining: 100% Polyester </li><li>Machine Wash Cold with like Colors. Do not Bleach. Tumble Dry Low. Do not Dry Clean. </li><li>Imported</li></ul>`,
            images:[
                {src: require('../assets/20000/20015 (1).webp')},
                {src: require('../assets/20000/20015 (2).webp')},
                {src: require('../assets/20000/20015 (3).webp')},
                {src: require('../assets/20000/20015 (4).webp')},
          
            ],
        },
        {
            id:20016,
            title:'Foil Metallic Slinky Cowl Maxi Dress',
            amount:'119.00',
            originalAmount:'',
            off:'',
            colors:[{name:'ivory/silver',src:require('../assets/color/white.webp')}],
            sizes:[{size:'XS'},{size:'S'},{size:'M'},{size:'L'},{size:'XL',},],
            sku:'BEBE2238F',
            categories:'dresses',
            categoryId:'20000',
            description:`Metallic shine, draped cowl neckline, and a slinky fit that moves like trouble. Wear it to NYE, birthday blowouts, and nights with a guest list.`,
            key:`<ul><li>Cowl Neck</li><li>Sleeveless</li><li>Ankle Length</li><li>Sleeveless</li></ul>`,
            care:`<ul><li>95% Polyester 5% Spandex</li><li>Hand Wash Cold Separated. Do not Bleach. Lay Flat to Dry. Cool Iron if Needed. Do not Dry Clean. </li><li>Made in USA</li></ul>`,
            images:[
                {src: require('../assets/20000/20016 (1).webp')},
                {src: require('../assets/20000/20016 (2).webp')},
                {src: require('../assets/20000/20016 (3).webp')},
                {src: require('../assets/20000/20016 (4).webp')},
        
            ],
        },
        {
            id:20017,
            title:'Pleated Skort Denim Dress',
            amount:'89.99',
            originalAmount:'149.00',
            off:'39',
            colors:[{name:'white',src:require('../assets/color/white.webp')}],
            sizes:[{size:'XS'},{size:'S'},{size:'M'},{size:'L'},{size:'XL',},],
            sku:'7SWN0229BE',
            categories:'dresses',
            categoryId:'20000',
            description:`Pleated skort denim dress in stretch denim with five-pocket swagger, pearl-and-rhinestone studs, and gold hardware.`,
            key:`<ul><li>Stretch Denim</li><li>Short Sleeves</li><li>Stretch Lining Short Under</li><li>Adjustable Back Tie</li><li>Removable Belt</li><li>Invisible Back Zipper</li><li>Gold Metal Hardware</li><li>32" Dress Length</li></ul>`,
            care:`<ul><li>Top: 98% Cotton, 2% Spandex; Bottom Combo, Bottom: 88% Nylon, 12% Spandex</li><li>Machine Wash In Delicate Cycle</li><li>Imported</li></ul>`,
            images:[
                {src: require('../assets/20000/20017 (1).webp')},
                {src: require('../assets/20000/20017 (2).webp')},
                {src: require('../assets/20000/20017 (3).webp')},
                {src: require('../assets/20000/20017 (4).webp')},
               
            ],
        },
        {
            id:20018,
            title:'Metal Strap Details Fitted Denim Dress',
            amount:'149.00',
            originalAmount:'',
            off:'',
            colors:[{name:'iconic blue wash',src:require('../assets/color/blue_wash.webp')}],
            sizes:[{size:'XS'},{size:'S'},{size:'M'},{size:'L'},{size:'XL',},],
            sku:'7SWN0224BE',
            categories:'dresses',
            categoryId:'20000',
            description:`A fitted denim dress with metal strap details, adding edge and attitude.`,
            key:`<ul><li>Stretch Denim</li><li> Sleeveless</li><li> Front Zipper Closure</li><li> Gold Hardware</li><li>31" Dress Length</li></ul>`,
            care:`<ul><li>99% Cotton, 1% Spandex</li><li>Machine Wash In Delicate Cycle</li><li>Imported</li></ul>`,
            images:[
                {src: require('../assets/20000/20018 (1).webp')},
                {src: require('../assets/20000/20018 (2).webp')},
                {src: require('../assets/20000/20018 (3).webp')},
                {src: require('../assets/20000/20018 (4).webp')},
   
            ],
        },
        {
            id:20019,
            title:'Bow Fitted Eyelet Denim Dress',
            amount:'68.99',
            originalAmount:'179.00',
            off:'61',
            colors:[{name:'antique indigo wash',src:require('../assets/color/antique-indigo-wash.webp')}],
            sizes:[{size:'XS'},{size:'S'},{size:'M'},{size:'L'},{size:'XL',},],
            sku:'7SWN0198BE',
            categories:'dresses',
            categoryId:'20000',
            description:`Opt for a fresh take on a classic style with this bow-fitted eyelet denim dress. A perfect day or night look.`,
            key:`<ul><li>Short Fitted Body Silhouette</li><li>Front Lace Up Suede Detail</li><li>Detachable Bow Brooch</li><li>Adjustable Straps</li><li><span>Open- End Back Zipper</span></li><li>34" Dress Length</li></ul>`,
            care:`<ul><li>99% Cotton, 1% Spandex</li><li>Machine Wash In Delicate Cycle</li><li>Imported</li></ul>`,
            images:[
                {src: require('../assets/20000/20019 (1).webp')},
                {src: require('../assets/20000/20019 (2).webp')},
                {src: require('../assets/20000/20019 (3).webp')},
                {src: require('../assets/20000/20019 (4).webp')},
                {src: require('../assets/20000/20019 (5).webp')},
           
            ],
        },
        {
            id:20020,
            title:'MINI PLEATED DENIM DRESS',
            amount:'149.00',
            originalAmount:'',
            off:'',
            colors:[{name:'blue obsession wash',src:require('../assets/color/blue_obsession_wash.webp')}],
            sizes:[{size:'XS'},{size:'S'},{size:'M'},{size:'L'},{size:'XL',},],
            sku:'7SWN0227BE',
            categories:'dresses',
            categoryId:'20000',
            description:`A pleated denim mini dress that combines playful details with an easy, wear-anywhere feel.`,
            key:`<ul><li>Stretch Denim </li><li>Fit-And-Flare Silhouette </li><li>Gold Hardware </li><li>Adjustable Straps To Be Worn Crossed Or Straight</li><li>   Top Length</li><li> 31" Bottom Inseam</li></ul>`,
            care:`<ul><li>99% Cotton, 1% Spandex</li><li>Machine Wash In Delicate Cycle</li><li>Imported</li></ul>`,
            images:[
                {src: require('../assets/20000/20020 (1).webp')},
                {src: require('../assets/20000/20020 (2).webp')},
                {src: require('../assets/20000/20020 (3).webp')},
                {src: require('../assets/20000/20020 (4).webp')},
             
            ],
        },
        {
            id:30001,
            title:'STRETCH HALTER TOP',
            amount:'109.00',
            originalAmount:'',
            off:'',
            colors:[{name:'dark cherry',src:require('../assets/color/dark_cherry.jpg')}],
            sizes:[{size:'XS'},{size:'S'},{size:'M'},{size:'L'},{size:'XL',},],
            sku:'7SKT0491BE',
            categories:'tops',
            categoryId:'30000',
            description:`A halter top designed to show a little skin and make every plan feel like the right one.`,
            key:`<ul><li>Soft Stretch Knit Fabric</li><li>Fitted Silhouette</li><li>Functional Front Hook-And-Eye Opening</li><li>Contouring Effect</li><li> 18" Top Length</li></ul>`,
            care:`<ul><li>67% Rayon, 28% Nylon, 5% Spandex;Mesh Combo: 92% Nylon, 8% Spandex</li><li>Hand Wash, Hang To Dry</li><li>Imported</li></ul>`,
            images:[
                {src: require('../assets/30000/30001 (1).webp')},
                {src: require('../assets/30000/30001 (2).webp')},
                {src: require('../assets/30000/30001 (3).webp')},
                {src: require('../assets/30000/30001 (4).webp')},
                {src: require('../assets/30000/30001 (5).webp')},
            ],
        },
        {
            id:30002,
            title:'FLORAL LACE BLOUSE',
            amount:'119.00',
            originalAmount:'',
            off:'',
            colors:[{name:'black',src:require('../assets/color/black_sw.webp')}],
            sizes:[{size:'XS'},{size:'S'},{size:'M'},{size:'L'},{size:'XL',},],
            sku:'7SKT1491BE',
            categories:'tops',
            categoryId:'30000',
            description:`A floral lace blouse that balances soft details with a confident, wear-anywhere attitude.`,
            key:`<ul><li>Lace Mixed With Liquid Satin </li><li>Fitted Silhouette </li><li>Shirring At Shoulders And Waist </li><li>Gold Eyelet Buttons</li><li> 23" Top Length</li></ul>`,
            care:`<ul><li>100% Polyester;Satin Combo: 90% Polyester, 10% Spandex</li><li>Hand Wash, Hang To Dry</li><li>Imported</li></ul>`,
            images:[
                {src: require('../assets/30000/30002 (1).webp')},
                {src: require('../assets/30000/30002 (2).webp')},
                {src: require('../assets/30000/30002 (3).webp')},
                {src: require('../assets/30000/30002 (4).webp')},
             
            ],
        },{
            id:30003,
            title:'Halter Denim Top',
            amount:'119.00',
            originalAmount:'',
            off:'',
            colors:[{name:'iconic blue wash',src:require('../assets/color/blue_wash.webp')}],
            sizes:[{size:'XS'},{size:'S'},{size:'M'},{size:'L'},{size:'XL',},],
            sku:'7SWT0483BE',
            categories:'tops',
            categoryId:'30000',
            description:`A fitted denim halter designed to accentuate your shoulders.`,
            key:`<ul><li>Peplum Silhouette</li><li>Halter Neckline</li><li>Elastic At Back Neckband</li><li>Sleeveless</li><li>22" Top Length</li></ul>`,
            care:`<ul><li>99% Cotton, 1% Spandex</li><li>Machine Wash In Delicate Cycle</li><li>Imported</li></ul>`,
            images:[
                {src: require('../assets/30000/30003 (1).webp')},
                {src: require('../assets/30000/30003 (2).webp')},
                {src: require('../assets/30000/30003 (3).webp')},
                {src: require('../assets/30000/30003 (4).webp')},
        
            ],
        },{
            id:30004,
            title:'Stretch Summer Knit Top',
            amount:'',
            originalAmount:'',
            off:'',
            colors:[{name:'black',src:require('../assets/color/black.webp')}],
            sizes:[{size:'XS'},{size:'S'},{size:'M'},{size:'L'},{size:'XL',},],
            sku:'7SKW0288BE',
            categories:'tops',
            categoryId:'30000',
            description:`A soft stretch knit top that hugs comfortably, made for warm days.`,
            key:`<ul><li>Fitted Silhouette</li><li> Stretch Fabric</li><li> Sleeveless With Gold Trim</li><li> Soft Yarn</li><li> 19" Top Length</li></ul>`,
            care:`<ul><li>60% Polyester, 40% Viscose</li><li>Hand Wash, Lay Flat To Dry</li><li>Imported</li></ul>`,
            images:[
                {src: require('../assets/30000/30004 (1).webp')},
                {src: require('../assets/30000/30004 (2).webp')},
                {src: require('../assets/30000/30004 (3).webp')},
                {src: require('../assets/30000/30004 (4).webp')},
             
            ],
        },{
            id:30005,
            title:'Stretch Lace Bodysuit',
            amount:'71.99 ',
            originalAmount:'119.00',
            off:'39',
            colors:[{name:'black',src:require('../assets/color/black.webp')}],
            sizes:[{size:'XS'},{size:'S'},{size:'M'},{size:'L'},{size:'XL',},],
            sku:'7SKB0162BE',
            categories:'tops',
            categoryId:'30000',
            description:`A stretch lace bodysuit with a deep V-neckline and delicate scalloped trim that layers seamlessly or makes a statement on its own. The intricate floral lace and sheer construction deliver a confident moment perfect for night plans.`,
            key:`<ul><li>Stretch lace</li><li>Lace mesh</li><li>Mix scallop edge</li><li>Gold metal trim</li><li>26 1/2" Top Length</li></ul>`,
            care:`<ul><li>82% Nylon, 18% Spandex</li><li>Mesh Combo: 95% Polyester, 5% Spandex</li><li>Hand wash, hang to dry</li><li>Imported</li></ul>`,
            images:[
                {src: require('../assets/30000/30005 (1).webp')},
                {src: require('../assets/30000/30005 (2).webp')},
                {src: require('../assets/30000/30005 (3).webp')},
                {src: require('../assets/30000/30005 (4).webp')},
                
            ],
        },
        {
            id:30006,
            title:'The Ruched Waist Shirt',
            amount:'33.00',
            originalAmount:'',
            off:'',
            colors:[{name:'white',src:require('../assets/color/white.webp')}],
            sizes:[{size:'XS'},{size:'S'},{size:'M'},{size:'L'},{size:'XL',},],
            sku:'BLZ85',
            categories:'tops',
            categoryId:'30000',
            description:``,
            key:`<ul><li>Button Down Front Closure</li><li>Elasticated Waist</li><li>Short Sleeves</li><li>Chest Pocket</li><li>Rhinestone Shoulder Detail Inseam/Length</li></ul>`,
            care:`<ul><li>100% Cotton Light Denim</li><li>Machine wash cold with like colors only non_chlotine bleach when needed tumble drey low warm iron if needed do not iron on decoration do not dry clean</li><li>Imported</li></ul>`,
            images:[
                {src: require('../assets/30000/30006 (1).webp')},
                {src: require('../assets/30000/30006 (2).webp')},
                {src: require('../assets/30000/30006 (3).webp')},
                {src: require('../assets/30000/30006 (4).webp')},
          
            ],
        },{
            id:30007,
            title:'The Cropped Trucker Vest',
            amount:'74.00',
            originalAmount:'',
            off:'',
            colors:[{name:'grey wash',src:require('../assets/color/grey-wash.webp')}],
            sizes:[{size:'XS'},{size:'S'},{size:'M'},{size:'L'},{size:'XL',},],
            sku:'BCV',
            categories:'tops',
            categoryId:'30000',
            description:`Add instant drama with this cropped vest featuring rhinestone fringe. Perfect for concerts, nights out, or when you’re craving a bold statement piece.`,
            key:`<ul><li>17.25 Inseam/Length</li></ul>`,
            care:`<ul><li>58% Cotton 26% Poly 14% Viscose 2% Spandex</li><li>Machine Wash Cold With Like Colors. Only Non-Chlorine Bleach When Needed. Tumble Dry Low. Warm Iron If Needed. Do Not Iron On Decoration. Do Not Dry Clean.</li><li>Made in USA</li></ul>`,
            images:[
                {src: require('../assets/30000/30007 (1).webp')},
                {src: require('../assets/30000/30007 (2).webp')},
                {src: require('../assets/30000/30007 (3).webp')},
                {src: require('../assets/30000/30007 (4).webp')},
         
            ],
        },
        {
            id:30008,
            title:'The Corset Tank',
            amount:'68.00',
            originalAmount:'',
            off:'',
            colors:[{name:'medium blue',src:require('../assets/color/medium_blue_sw.webp')}],
            sizes:[{size:'XS'},{size:'S'},{size:'M'},{size:'L'},{size:'XL',},],
            sku:'7SKT0488BE',
            categories:'tops',
            categoryId:'30000',
            description:`This denim corset offers a sculpted silhouette and versatile appeal. Pair with your favorite bebe denim in the same wash to complete the look.`,
            key:`<ul><li>70% Cotton 28% Polyester 2% Spandex</li><li>Machine Wash Cold With Like Colors, Only Non-Chlorine Bleach When Needed, Tumble Dry Low, Warm Iron If Needed, Do Not Iron On Decoration, Do Not Dry Clean.</li><li>Imported</li></ul>`,
            care:``,
            images:[
                {src: require('../assets/30000/30008 (1).webp')},
                {src: require('../assets/30000/30008 (2).webp')},
                {src: require('../assets/30000/30008 (3).webp')},
                {src: require('../assets/30000/30008 (4).webp')},
          
            ],
        },
        {
            id:30009,
            title:'MOTOR BIKE BODYSUIT',
            amount:'119.00',
            originalAmount:'',
            off:'',
            colors:[{name:'black/white',src:require('../assets/color/black.webp')}],
            sizes:[{size:'XS'},{size:'S'},{size:'M'},{size:'L'},{size:'XL',},],
            sku:'7SKT0484BE',
            categories:'tops',
            categoryId:'30000',
            description:`A moto-inspired bodysuit that adds instant edge to denim, trousers, and everything in between.`,
            key:`<ul><li>Soft Stretch Fabric</li><li>Fitted Silhouette</li><li>White Contrast Piping Details</li><li>Mesh Inserts</li><li> 27" Top Length</li></ul>`,
            care:`<ul><li>75% Nylon, 25% Spandex;Mesh Combo: 95% Polyester, 5% Spandex</li><li>Hand Wash, Hang To Dry</li><li>Imported</li></ul>`,
            images:[
                {src: require('../assets/30000/30009 (1).webp')},
                {src: require('../assets/30000/30009 (2).webp')},
                {src: require('../assets/30000/30009 (3).webp')},
                {src: require('../assets/30000/30009 (4).webp')},
           
            ],
        },
        {
            id:30010,
            title:'Beaded Halter Top',
            amount:'64.99',
            originalAmount:'',
            off:'',
            colors:[{name:'sundust',src:require('../assets/color/sundust.webp')}],
            sizes:[{size:'XS'},{size:'S'},{size:'M'},{size:'L'},{size:'XL',},],
            sku:'7SKT0486BE',
            categories:'tops',
            categoryId:'30000',
            description:`A halter silhouette with bead accents that catch the light, perfect for nights out or spontaneous plans that run late.`,
            key:`<ul><li>Stretch Knit</li><li>Front Cutout</li><li>Detail Halter</li><li>Clear Teardrop Beads</li><li>Bodice</li><li>Shirring</li><li>17" Top Length</li></ul>`,
            care:`<ul><li>93% Polyester, 7% Spandex</li><li>Hand Wash, Hang To Dry</li><li>Imported</li></ul>`,
            images:[
                {src: require('../assets/30000/30010 (1).webp')},
                {src: require('../assets/30000/30010 (2).webp')},
                {src: require('../assets/30000/30010 (3).webp')},
                {src: require('../assets/30000/30010 (4).webp')},
            
            ],
        },
        {
            id:30011,
            title:'Resort Halter Flowy Top',
            amount:'71.99',
            originalAmount:'119.00',
            off:'39',
            colors:[{name:'deep lagoon',src:require('../assets/color/deep_lagoon.webp')}],
            sizes:[{size:'XS'},{size:'S'},{size:'M'},{size:'L'},{size:'XL',},],
            sku:'7SWT0484BE',
            categories:'tops',
            categoryId:'30000',
            description:`An open halter neckline and breezy fit that feels carefree.`,
            key:`<ul><li>Gradient Effect</li><li> Halter</li><li> Metal Gold Trim</li><li> 22" Top Length</li></ul>`,
            care:`<ul><li>100% Polyester</li><li>Hand Wash, Hang To Dry</li><li>Imported</li></ul>`,
            images:[
                {src: require('../assets/30000/30011 (1).webp')},
                {src: require('../assets/30000/30011 (2).webp')},
                {src: require('../assets/30000/30011 (3).webp')},
                {src: require('../assets/30000/30011 (4).webp')},
              
            ],
        },
        {
            id:30012,
            title:'Beaded Belt Flowy Blouse',
            amount:'68.99',
            originalAmount:'119.00 ',
            off:'42',
            colors:[{name:'islabloom',src:require('../assets/color/islabloom.webp')}],
            sizes:[{size:'XS'},{size:'S'},{size:'M'},{size:'L'},{size:'XL',},],
            sku:'7SWL0244BE',
            categories:'tops',
            categoryId:'30000',
            description:`A loose, drapey blouse finished with a beaded belt detail.`,
            key:`<ul><li>Removable Beaded String Belt</li><li> Flowy Long Sleeve</li><li> Cropped Top</li><li> 15" Top Length</li></ul>`,
            care:`<ul><li>100% Viscose;Lining: 100% Polyester</li><li>Hand Wash, Hang To Dry</li><li>Imported</li></ul>`,
            images:[
                {src: require('../assets/30000/30012 (1).webp')},
                {src: require('../assets/30000/30012 (2).webp')},
                {src: require('../assets/30000/30012 (3).webp')},
                {src: require('../assets/30000/30012 (4).webp')},
                {src: require('../assets/30000/30012 (5).webp')},
             
            ],
        },{
            id:30013,
            title:'Versatile Scarf Linen Top',
            amount:'62.99',
            originalAmount:'109.00',
            off:'42',
            colors:[{name:'deep lagoon',src:require('../assets/color/deep_lagoon.webp')}],
            sizes:[{size:'XS'},{size:'S'},{size:'M'},{size:'L'},{size:'XL',},],
            sku:'7SWT0488BE',
            categories:'tops',
            categoryId:'30000',
            description:`A scarf-style linen top designed to tie multiple ways.`,
            key:`<ul><li>Versatile Bandana</li><li> Linen Top</li><li> 18" Top Length</li></ul>`,
            care:`<ul><li>70% Rayon, 30% Linen;Lining: 100% Cotton</li><li>Hand Wash, Hang To Dry</li><li>Imported</li></ul>`,
            images:[
                {src: require('../assets/30000/30013 (1).webp')},
                {src: require('../assets/30000/30013 (2).webp')},
                {src: require('../assets/30000/30013 (3).webp')},
                {src: require('../assets/30000/30013 (4).webp')},
            
            ],
        },
        {
            id:30014,
            title:'Shell-Look Button Knit Top',
            amount:'62.99',
            originalAmount:'109.00',
            off:'42',
            colors:[{name:'vanilla heat',src:require('../assets/color/Vanilla_Heat.webp')}],
            sizes:[{size:'XS'},{size:'S'},{size:'M'},{size:'L'},{size:'XL',},],
            sku:'7SKW0282BE',
            categories:'tops',
            categoryId:'30000',
            description:`A ribbed knit tank scattered with shell-look buttons for a twist on a wardrobe staple. The scoop neckline and fitted silhouette keep it sleek, while the dimensional button details add unexpected texture - perfect for the office, lunch dates, and weekend out.`,
            key:`<ul><li>Soft stretch fabric</li><li>Sleeveless</li><li>Button decorative trims</li><li>22" Top Length</li></ul>`,
            care:`<ul><li>60% Polyester, 40% Viscose</li><li>Hand wash, lay flat to dry</li><li>Imported</li></ul>`,
            images:[
                {src: require('../assets/30000/30014 (1).webp')},
                {src: require('../assets/30000/30014 (2).webp')},
                {src: require('../assets/30000/30014 (3).webp')},
                {src: require('../assets/30000/30014 (4).webp')},
        
            ],
        },
        {
            id:30015,
            title:'One Shoulder Bustier Top',
            amount:'62.99',
            originalAmount:'109.00',
            off:'42',
            colors:[{name:'papaya punch',src:require('../assets/color/Papaya_Punch.webp')}],
            sizes:[{size:'XS'},{size:'S'},{size:'M'},{size:'L'},{size:'XL',},],
            sku:'7SKT0480BE',
            categories:'tops',
            categoryId:'30000',
            description:`A one-shoulder bustier top that spotlights your shoulders and shapes the waist.`,
            key:`<ul><li>Stretch one shoulder</li><li>Shirring cropped</li><li>15" Top Length</li></ul>`,
            care:`<ul><li>95% Polyester, 5% Spandex</li><li>Lining: 95% Polyester, 5% Spandex<br></li><li>Hand wash, hang to dry</li><li>Imported</li></ul>`,
            images:[
                {src: require('../assets/30000/30015 (1).webp')},
                {src: require('../assets/30000/30015 (2).webp')},
                {src: require('../assets/30000/30015 (3).webp')},
        
            
            ],
        },
        {
            id:30016,
            title:'Neck Tie Smocked Linen Top',
            amount:'62.99',
            originalAmount:'109.00',
            off:'42',
            colors:[{name:'ocean veil',src:require('../assets/color/Ocean_Veil.webp')}],
            sizes:[{size:'XS'},{size:'S'},{size:'M'},{size:'L'},{size:'XL',},],
            sku:'7SWT0481BE',
            categories:'tops',
            categoryId:'30000',
            description:`A smocked linen top that holds you comfortably with a neck-tie finish. Wear it for patio lunches, weekend plans, and warm-weather getaways. Looks great with denim or matching linen bottoms.`,
            key:`<ul><li>Smocking ruffle detail</li><li>Halter</li><li>Gold metal trim</li><li>18" Top Length</li></ul>`,
            care:`<ul><li>90% Lyocell, 10% Linen</li><li>Lining: 100% Cotton</li><li>Hand wash, hang to dry</li><li>Imported</li></ul>`,
            images:[
                {src: require('../assets/30000/30016 (1).webp')},
                {src: require('../assets/30000/30016 (2).webp')},
                {src: require('../assets/30000/30016 (3).webp')},
                {src: require('../assets/30000/30016 (4).webp')},
                {src: require('../assets/30000/30016 (5).webp')},
             
            ],
        },
        {
            id:30017,
            title:'Tie Front Linen Top',
            amount:'62.99',
            originalAmount:'109.00',
            off:'42',
            colors:[{name:'white alyssum',src:require('../assets/color/white.webp')}],
            sizes:[{size:'XS'},{size:'S'},{size:'M'},{size:'L'},{size:'XL',},],
            sku:'7SWT0477BE',
            categories:'tops',
            categoryId:'30000',
            description:`A tie-front linen top that cinches your waist and keeps things breathable. Perfect for daytime dates, city strolls, and vacation dinners.`,
            key:`<ul><li>Fitted</li><li>Front tie collar</li><li>Ruffle gold metal trim</li><li>19" Top Length</li></ul>`,
            care:`<ul><li>70% Rayon, 30% Linen</li><li>Lining: 100% Cotton</li><li>Hand wash, hang to dry</li><li>Imported</li></ul>`,
            images:[
                {src: require('../assets/30000/30017 (1).webp')},
                {src: require('../assets/30000/30017 (2).webp')},
                {src: require('../assets/30000/30017 (3).webp')},
                {src: require('../assets/30000/30017 (4).webp')},
                {src: require('../assets/30000/30017 (5).webp')},
         
            ],
        },
        {
            id:30018,
            title:'Twisted Strap Knit Top',
            amount:'98.00',
            originalAmount:'',
            off:'',
            colors:[{name:'ocean veil',src:require('../assets/color/Ocean_Veil_ws.webp')}],
            sizes:[{size:'XS'},{size:'S'},{size:'M'},{size:'L'},{size:'XL',},],
            sku:'7SKW0285BE',
            categories:'tops',
            categoryId:'30000',
            description:`A knit womenÕs top with twisted straps and a close, flattering fit. Great for dinner reservations, casual cocktails, and weekend plans.`,
            key:`<ul><li>Soft stretch fabric</li><li>Sleeveless</li><li>Gold trims</li><li>21 1/2" Top Length</li></ul>`,
            care:`<ul><li>60% Polyester, 40% Viscose</li><li>Hand wash, lay flat to dry</li><li>Imported</li></ul>`,
            images:[
                {src: require('../assets/30000/30018 (1).webp')},
                {src: require('../assets/30000/30018 (2).webp')},
                {src: require('../assets/30000/30018 (3).webp')},
                {src: require('../assets/30000/30018 (4).webp')},
                {src: require('../assets/30000/30018 (5).webp')},
           
            ],
        },
        {
            id:30019,
            title:'Lace Up Linen Top',
            amount:'62.99',
            originalAmount:'109.00',
            off:'42',
            colors:[{name:'white alyssum',src:require('../assets/color/white.webp')}],
            sizes:[{size:'XS'},{size:'S'},{size:'M'},{size:'L'},{size:'XL',},],
            sku:'7SWT0475BE',
            categories:'tops',
            categoryId:'30000',
            description:`A breathable linen top with lace-up detail for an adjustable, skin-showing fit. Ideal for vacations, brunch, and beachside dinners. Style with linen shorts and layered jewelry.`,
            key:`<ul><li>Side lace up</li><li>Fitted</li><li>Gold metal trim</li><li>18 1/2" Top Length</li></ul>`,
            care:`<ul><li>70% Rayon, 30% Linen</li><li>Lining: 100% Cotton</li><li>Hand wash, hang to dry</li><li>Imported</li></ul>`,
            images:[
                {src: require('../assets/30000/30019 (1).webp')},
                {src: require('../assets/30000/30019 (2).webp')},
                {src: require('../assets/30000/30019 (3).webp')},
                {src: require('../assets/30000/30019 (4).webp')},
                {src: require('../assets/30000/30019 (5).webp')},
                
            ],
        },
        {
            id:30020,
            title:'Luxe Shine Fitted Top',
            amount:'58.99',
            originalAmount:'98.00',
            off:'39',
            colors:[{name:'black',src:require('../assets/color/black.webp')}],
            sizes:[{size:'XS'},{size:'S'},{size:'M'},{size:'L'},{size:'XL',},],
            sku:'7SKT0478BE',
            categories:'tops',
            categoryId:'30000',
            description:`A glossy women’s fitted top that hugs close and catches every light. Wear it for date night, rooftop drinks, or concerts. Pair with high-rise jeans, a mini skirt, and heels.`,
            key:`<ul><li>Stretch fabric</li><li>Fitted</li><li>Small chest cutout detail</li><li>Gold metal trim</li><li>19 1/2" Top Length</li></ul>`,
            care:`<ul><li>95% Polyester, 5% Spandex</li><li>Lining: 95% Polyester, 5% Spandex<br></li><li>Hand wash, hand to dry</li><li>Imported</li></ul>`,
            images:[
                {src: require('../assets/30000/30020 (1).webp')},
                {src: require('../assets/30000/30020 (2).webp')},
                {src: require('../assets/30000/30020 (3).webp')},
                {src: require('../assets/30000/30020 (4).webp')},
                {src: require('../assets/30000/30020 (5).webp')},
           
            ],
        },
        {
            id:40001,
            title:'HIGH WAIST SATIN ELASTIC WAISTBAND LEGGING',
            amount:'109.00',
            originalAmount:'',
            off:'',
            colors:[{name:'dark cherry',src:require('../assets/color/dark_cherry.jpg')}],
            sizes:[{size:'XS'},{size:'S'},{size:'M'},{size:'L'},{size:'XL',},],
            sku:'7SKP0422BE',
            categories:'bottoms',
            categoryId:'40000',
            description:`A satin-finish legging that brings a little extra shine to your everyday rotation.`,
            key:`<ul><li>Soft Stretch Fabric </li><li>Bandage Elastic Waistband </li><li>Zipper Opening At Back </li><li>Bodycon</li><li>   Top Length</li><li> 28" Bottom Inseam</li></ul>`,
            care:`<ul><li>67% Rayon, 28% Nylon, 5% Spandex</li><li>Hand Wash, Hang To Dry</li><li>Imported</li></ul>`,
            images:[
                {src: require('../assets/40000/40001 (1).webp')},
                {src: require('../assets/40000/40001 (2).webp')},
                {src: require('../assets/40000/40001 (3).webp')},
                {src: require('../assets/40000/40001 (4).webp')},
            
            ],
        },
        {
            id:40002,
            title:'VEGAN LEATHER BERMUDA PANTS',
            amount:'119.00',
            originalAmount:'',
            off:'',
            colors:[{name:'black',src:require('../assets/color/black.webp')}],
            sizes:[{size:'XS'},{size:'S'},{size:'M'},{size:'L'},{size:'XL',},],
            sku:'7SWS0093BE',
            categories:'bottoms',
            categoryId:'40000',
            description:`Vegan leather bermuda pants that bring a bold, fashion-forward twist to your everyday wardrobe.`,
            key:`<ul><li>Stretch Vegan Leather </li><li>Bermuda Length </li><li>Overlap Waist Detail </li><li>Gold Buttons</li><li>   Top Length</li><li> 10" Bottom Inseam</li></ul>`,
            care:`<ul><li>100% Polyurethane</li><li>Hand Wash, Hang To Dry</li><li>Imported</li></ul>`,
            images:[
                {src: require('../assets/40000/40002 (1).webp')},
                {src: require('../assets/40000/40002 (2).webp')},
                {src: require('../assets/40000/40002 (3).webp')},
                {src: require('../assets/40000/40002 (4).jpg')},
       
            ],
        },
        {
            id:40003,
            title:'CAPRI CARGO JOGGER',
            amount:'119.00',
            originalAmount:'',
            off:'',
            colors:[{name:'chocolate martini',src:require('../assets/color/chocolate_martini.webp')}],
            sizes:[{size:'XS'},{size:'S'},{size:'M'},{size:'L'},{size:'XL',},],
            sku:'7SWP0433BE',
            categories:'bottoms',
            categoryId:'40000',
            description:`A cargo jogger with a laid-back feel and just enough edge to keep things interesting.`,
            key:`<ul><li>Soft Liquid Satin Fabric </li><li>Capri Length </li><li>Gold Metal Trims </li><li>Cargo Pockets</li><li>   Top Length</li><li> 18" Bottom Inseam</li></ul>`,
            care:`<ul><li>90% Polyester, 10% Spandex</li><li>Hand Wash, Hang To Dry</li><li>Imported</li></ul>`,
            images:[
                {src: require('../assets/40000/40003 (1).webp')},
                {src: require('../assets/40000/40003 (2).webp')},
                {src: require('../assets/40000/40003 (3).webp')},
                {src: require('../assets/40000/40003 (4).webp')},
          
            ],
        },
        {
            id:40004,
            title:'TAILORED HIGH WAIST STRAIGHT LEG PANTS',
            amount:'139.00',
            originalAmount:'',
            off:'',
            colors:[{name:'black',src:require('../assets/color/black.webp')}],
            sizes:[{size:'XS'},{size:'S'},{size:'M'},{size:'L'},{size:'XL',},],
            sku:'7SWP0435BE',
            categories:'bottoms',
            categoryId:'40000',
            description:`High-waisted straight-leg pants that create a polished look without trying too hard.`,
            key:`<ul><li>Soft Woven Twill Fabric </li><li>White Contrast Piping Details </li><li>Belt With Gold Buckle</li><li>   Top Length</li><li> 32" Bottom Inseam</li></ul>`,
            care:`<ul><li>72% Polyester, 21% Viscose, 7% Spandex</li><li>Hand Wash, Hang To Dry</li><li>Imported</li></ul>`,
            images:[
                {src: require('../assets/40000/40004 (1).webp')},
                {src: require('../assets/40000/40004 (2).webp')},
                {src: require('../assets/40000/40004 (3).webp')},
                {src: require('../assets/40000/40004 (4).webp')},
            
            ],
        },
        {
            id:40005,
            title:'Flowy Flared Skirt',
            amount:'129.00',
            originalAmount:'',
            off:'',
            colors:[{name:'islabloom',src:require('../assets/color/islabloom.webp')}],
            sizes:[{size:'XS'},{size:'S'},{size:'M'},{size:'L'},{size:'XL',},],
            sku:'7SWK0195BE',
            categories:'bottoms',
            categoryId:'40000',
            description:`A lightweight flared skirt made for movement.`,
            key:`<ul><li>Ruffle Detail</li><li> Shirring Flowy Skirt</li><li>   Top Length</li><li> 37" Skirt Length</li></ul>`,
            care:`<ul><li>100% Viscose;Lining: 100% Polyester</li><li>Hand Wash, Hang To Dry</li><li>Imported</li></ul>`,
            images:[
                {src: require('../assets/40000/40005 (1).webp')},
                {src: require('../assets/40000/40005 (2).webp')},
                {src: require('../assets/40000/40005 (3).webp')},
                {src: require('../assets/40000/40005 (4).webp')},
          
            ],
        },
        {
            id:40006,
            title:'Capri Jegging',
            amount:'98.00',
            originalAmount:'',
            off:'',
            colors:[{name:'medium blue wash',src:require('../assets/color/blue_wash.webp')}],
            sizes:[{size:'XS'},{size:'S'},{size:'M'},{size:'L'},{size:'XL',},],
            sku:'7SKD0212BE',
            categories:'bottoms',
            categoryId:'40000',
            description:`A cropped jegging that looks like denim but wears like leggings.`,
            key:`<ul><li>Soft Stretch Denim</li><li> 5 Pocket</li><li> Elasticated Waistband</li><li> Gold Hardware</li><li>20" Bottom Inseam</li></ul>`,
            care:`<ul><li>46% Cotton, 44% Polyester, 10% Spandex</li><li>Machine Wash In Delicate Cycle</li><li>Imported</li></ul>`,
            images:[
                {src: require('../assets/40000/40006 (1).jpg')},
                {src: require('../assets/40000/40006 (2).webp')},
                {src: require('../assets/40000/40006 (3).webp')},
                {src: require('../assets/40000/40006 (4).webp')},
            
            ],
        },
        {
            id:40007,
            title:'Natural Waisted Jeggings',
            amount:'98.00',
            originalAmount:'',
            off:'',
            colors:[{name:'midnight blue wash',src:require('../assets/color/blue_wash.webp')}],
            sizes:[{size:'XS'},{size:'S'},{size:'M'},{size:'L'},{size:'XL',},],
            sku:'7SKD0198BE',
            categories:'bottoms',
            categoryId:'40000',
            description:`A comfortable mid-rise jegging designed for everyday wear.`,
            key:`<ul><li>Stretch Fabric</li><li> 5 Pocket</li><li> Elastic Inside Waistband</li><li> Rhinestone Rivet Detail</li><li> Back Pocket Rhinestone</li><li>28" Bottom Inseam</li></ul>`,
            care:`<ul><li>46% Cotton, 44% Polyester, 10% Spandex</li><li>Machine Wash In Delicate Cycle</li><li>Imported</li></ul>`,
            images:[
                {src: require('../assets/40000/40007 (1).webp')},
                {src: require('../assets/40000/40007 (2).webp')},
                {src: require('../assets/40000/40007 (3).webp')},
                {src: require('../assets/40000/40007 (4).webp')},
       
            ],
        },
        {
            id:40008,
            title:'Fitted Denim Short',
            amount:'98.00',
            originalAmount:'',
            off:'',
            colors:[{name:'blue obsession wash',src:require('../assets/color/blue_obsession_wash.webp')}],
            sizes:[{size:'XS'},{size:'S'},{size:'M'},{size:'L'},{size:'XL',},],
            sku:'7SWS0089BE',
            categories:'bottoms',
            categoryId:'40000',
            description:`A fitted denim short that hugs in all the right places and styles endlessly. Wear it for weekend plans, festivals, and casual nights.`,
            key:`<ul><li>Fitted leg silhouette</li><li>Functional pockets front and back</li><li>Front fly zipper</li><li>3" Bottom Waist</li></ul>`,
            care:`<ul><li>99% Cotton, 1% Spandex</li><li>Machine wash in delicate cycle</li><li>Imported</li></ul>`,
            images:[
                {src: require('../assets/40000/40008 (1).webp')},
                {src: require('../assets/40000/40008 (2).webp')},
                {src: require('../assets/40000/40008 (3).jpg')},
                {src: require('../assets/40000/40008 (4).webp')},
                {src: require('../assets/40000/40008 (5).webp')},
              
            ],
        },
        {
            id:40009,
            title:'High Waist Draped Flare Leg Legging',
            amount:'63.99',
            originalAmount:'109.00',
            off:'41',
            colors:[{name:'black',src:require('../assets/color/black.webp')}],
            sizes:[{size:'XS'},{size:'S'},{size:'M'},{size:'L'},{size:'XL',},],
            sku:'7SKP0403BE',
            categories:'bottoms',
            categoryId:'40000',
            description:`High waist draped flare leggings with a leg-lengthening flare and stylish drape. Wear with platform heels or sneakers for concert outfits, date nights, and trendy streetwear.`,
            key:`<ul><li> Stretch Fabric</li><li> Elastic Inside Waistband</li><li> Gold Metal Hardware</li><li> 32" Bottom Inseam</li></ul>`,
            care:`<ul><li>85% Nylon, 15% Spandex</li><li>Hand Wash, Hang To Dry</li><li>Imported</li></ul>`,
            images:[
                {src: require('../assets/40000/40009 (1).webp')},
                {src: require('../assets/40000/40009 (2).webp')},
                {src: require('../assets/40000/40009 (3).webp')},
                {src: require('../assets/40000/40009 (4).webp')},
                {src: require('../assets/40000/40009 (5).webp')},
         
            ],
        },
        {
            id:40010,
            title:'Gold Chain Linen Short',
            amount:'64.99',
            originalAmount:'109.00',
            off:'40',
            colors:[{name:'white alyssum',src:require('../assets/color/white.webp')}],
            sizes:[{size:'XS'},{size:'S'},{size:'M'},{size:'L'},{size:'XL',},],
            sku:'7SWS0091BE',
            categories:'bottoms',
            categoryId:'40000',
            description:`Easy linen shorts upgraded with a gold chain accent.`,
            key:`<ul><li>Side Opening Detail</li><li> Gold Metal Hardware</li><li> Linen Short</li><li> 2" Bottom Inseam</li></ul>`,
            care:`<ul><li>70% Rayon, 30% Linen;Lining: 100% Cotton</li><li>Hand Wash, Hang To Dry</li><li>Imported</li></ul>`,
            images:[
                {src: require('../assets/40000/40010 (1).webp')},
                {src: require('../assets/40000/40010 (2).webp')},
                {src: require('../assets/40000/40010 (3).webp')},
                {src: require('../assets/40000/40010 (4).webp')},
          
            ],
        },
        {
            id:40011,
            title:'High Waist Corset Illusion Legging',
            amount:'59.99',
            originalAmount:'109.00',
            off:'44',
            colors:[{name:'black',src:require('../assets/color/black.webp')}],
            sizes:[{size:'XS'},{size:'S'},{size:'M'},{size:'L'},{size:'XL',},],
            sku:'7SKP0399BE',
            categories:'bottoms',
            categoryId:'40000',
            description:`Corset-illusion waistband leggings that cinch visually and move easily. Wear for nights out with a blazer, or daytime with an oversized shirt.`,
            key:`<ul><li>Fitted Silhouette</li><li> Stretch Fabric</li><li> Elastic Inside Waistband</li><li> Satin Tape Detail</li><li> 28" Bottom Inseam</li></ul>`,
            care:`<ul><li>67% Rayon, 28% Nylon, 5% Spandex</li><li>Hand Wash, Hang To Dry</li><li>Imported</li></ul>`,
            images:[
                {src: require('../assets/40000/40011 (1).webp')},
                {src: require('../assets/40000/40011 (2).webp')},
                {src: require('../assets/40000/40011 (3).webp')},
                {src: require('../assets/40000/40011 (4).webp')},
        
            ],
        },
        {
            id:40012,
            title:'High Waist Ruffle Hem Pant',
            amount:'63.99',
            originalAmount:'119.00',
            off:'46',
            colors:[{name:'black',src:require('../assets/color/black.webp')}],
            sizes:[{size:'XS'},{size:'S'},{size:'M'},{size:'L'},{size:'XL',},],
            sku:'7SKP0410BE',
            categories:'bottoms',
            categoryId:'40000',
            description:`High‑waisted pants with a ruffle hem add movement and romance. Ideal for evening plans, statement styling, and flowing silhouettes.`,
            key:`<ul><li>Georgette Fabric</li><li> Gold Metal Hardware</li><li> Stretch Knit Short Inside</li><li> Back Elasticated Waist</li><li> 31 1/2" Bottom Inseam</li></ul>`,
            care:`<ul><li>100%Polyester;Lining: 85% Nylon, 15% Spandex</li><li>Hand Wash, Hang To Dry</li><li>Imported</li></ul>`,
            images:[
                {src: require('../assets/40000/40012 (1).webp')},
                {src: require('../assets/40000/40012 (2).webp')},
                {src: require('../assets/40000/40012 (3).webp')},
                {src: require('../assets/40000/40012 (4).webp')},
                {src: require('../assets/40000/40012 (5).webp')},
      
            ],
        },
        {
            id:40013,
            title:'Pull-On Gathered Bubble Skort',
            amount:'63.99',
            originalAmount:'109.00',
            off:'41',
            colors:[{name:'butter cream',src:require('../assets/color/butter_cream.webp')}],
            sizes:[{size:'XS'},{size:'S'},{size:'M'},{size:'L'},{size:'XL',},],
            sku:'7SWK0190BE',
            categories:'bottoms',
            categoryId:'40000',
            description:`A playful bubble‑hem skort with gathered volume and easy pull‑on fit. Perfect for daytime styling, weekend plans, and standout casual looks.`,
            key:`<ul><li>Poplin Fabric</li><li> Gold Metal Hardware</li><li> Stretch Knit Short Inside</li><li> Elasticated Waist</li><li> 14" Skirt Length</li><li> 3" Bottom Inseam</li></ul>`,
            care:`<ul><li>97% Cotton, 3% Spandex;Lining: 95% Polyester, 5% Spandex</li><li>Hand Wash, Hang To Dry</li><li>Imported</li></ul>`,
            images:[
                {src: require('../assets/40000/40013 (1).webp')},
                {src: require('../assets/40000/40013 (2).webp')},
                {src: require('../assets/40000/40013 (3).webp')},
                {src: require('../assets/40000/40013 (4).webp')},
            
            ],
        },
        {
            id:40014,
            title:'High Waist Draped Sash Legging',
            amount:'63.99',
            originalAmount:'109.00',
            off:'41',
            colors:[{name:'black',src:require('../assets/color/black.webp')}],
            sizes:[{size:'XS'},{size:'S'},{size:'M'},{size:'L'},{size:'XL',},],
            sku:'7SKP0401BE',
            categories:'bottoms',
            categoryId:'40000',
            description:`High waist draped sash leggings with a flattering wrap detail for a snatched look. Style with a crop top and heels for going out outfits, dinner dates, and lounge nights.`,
            key:`<ul><li>Fitted Silhouette</li><li> Stretch Fabric</li><li> Elastic Inside Waistband</li><li> Gold Metal Hardware</li><li> 28" Bottom Inseam</li></ul>`,
            care:`<ul><li>85% Nylon, 15% Spandex</li><li>Hand Wash, Hang To Dry</li><li>Imported</li></ul>`,
            images:[
                {src: require('../assets/40000/40014 (1).webp')},
                {src: require('../assets/40000/40014 (2).webp')},
                {src: require('../assets/40000/40014 (3).webp')},
                {src: require('../assets/40000/40014 (4).webp')},
                {src: require('../assets/40000/40014 (5).webp')},
           
            ],
        },
        {
            id:40015,
            title:'Ladies Knit Leggings',
            amount:'63.99',
            originalAmount:'119.00',
            off:'46',
            colors:[{name:'black',src:require('../assets/color/black.webp')}],
            sizes:[{size:'XS'},{size:'S'},{size:'M'},{size:'L'},{size:'XL',},],
            sku:'7SKP0390BE',
            categories:'bottoms',
            categoryId:'40000',
            description:`Ladies knit leggings with stretch that hugs, elastic waistband, and silver studs tracing your stride. Throw on a crop tee and heels for night drinks, or sneakers for airport sprints and coffee runs.`,
            key:`<ul><li>Stretch Fabric</li><li> Elastic Inside Waistband</li><li> Silver Hot-Fix Stud Along Front Leg</li><li> 28" Bottom Inseam</li></ul>`,
            care:`<ul><li>67% Rayon, 28% Nylon, 5% Spandex</li><li>Dry Clean</li><li>Imported</li></ul>`,
            images:[
                {src: require('../assets/40000/40015 (1).webp')},
                {src: require('../assets/40000/40015 (2).webp')},
                {src: require('../assets/40000/40015 (3).webp')},
                {src: require('../assets/40000/40015 (4).webp')},
                {src: require('../assets/40000/40015 (5).webp')},
           
            ],
        },
        {
            id:40016,
            title:'Fitted Midi Knit Skirt',
            amount:'119.00',
            originalAmount:'',
            off:'',
            colors:[{name:'black',src:require('../assets/color/black.webp')}],
            sizes:[{size:'XS'},{size:'S'},{size:'M'},{size:'L'},{size:'XL',},],
            sku:'7SKK0193BE',
            categories:'bottoms',
            categoryId:'40000',
            description:`A fitted midi knit skirt that hugs your shape and moves with you. Perfect for dinner, work events, and weekend dates.`,
            key:`<ul><li>Stretch fabric</li><li>Shirring slit</li><li>Midi length</li><li>Gold metal trim</li><li>31" Skirt Length</li></ul>`,
            care:`<ul><li>93% Polyester, 7% Spandex</li><li>Hand wash, hang to dry</li><li>Imported</li></ul>`,
            images:[
                {src: require('../assets/40000/40016 (1).webp')},
                {src: require('../assets/40000/40016 (2).webp')},
                {src: require('../assets/40000/40016 (3).webp')},
                {src: require('../assets/40000/40016 (4).webp')},
            
            ],
        },
        {
            id:40017,
            title:'Sequin Maxi Skirt',
            amount:'72.99',
            originalAmount:'139.00',
            off:'47',
            colors:[{name:'black',src:require('../assets/color/black_sw2.webp')}],
            sizes:[{size:'XS'},{size:'S'},{size:'M'},{size:'L'},{size:'XL',},],
            sku:'7SKK0182BE',
            categories:'bottoms',
            categoryId:'40000',
            description:`Countdown drama comes to life with this glistening sequin maxi skirt. Flowing yet glamorous, it’s party-perfection for evening events or celebratory festivities.`,
            key:`<ul><li>Stretch Fabric</li><li> Short Inside Lining</li><li> Open-End Front Silver Zipper</li><li> 42" Skirt Length</li></ul>`,
            care:`<ul><li>100% Polyester;Lining: 95% Polyester, 5% Spandex</li><li>Dry Clean</li><li>Imported</li></ul>`,
            images:[
                {src: require('../assets/40000/40017 (1).webp')},
                {src: require('../assets/40000/40017 (2).webp')},
                {src: require('../assets/40000/40017 (3).webp')},
                {src: require('../assets/40000/40017 (4).webp')},
            
            ],
        },
        {
            id:40018,
            title:'Heart Embossed Vegan Leather Mini Skirt',
            amount:'65.99',
            originalAmount:'119.00',
            off:'44',
            colors:[{name:'tango red',src:require('../assets/color/red.webp')}],
            sizes:[{size:'XS'},{size:'S'},{size:'M'},{size:'L'},{size:'XL',},],
            sku:'7SKK0185BE',
            categories:'bottoms',
            categoryId:'40000',
            description:`Heart-embossed vegan leather mini skirt with stretch, lining, and a sleek side zip. Pair with a ribbed top for day flirting, a corset for nights out, and boots for concerts.`,
            key:`<ul><li>Stretch Fabric</li><li> Side Zipper</li><li> Fully Lined</li><li> 16" Skirt Length</li></ul>`,
            care:`<ul><li>100% Polyurethane;Lining: 90% Polyetser, 10% Spandex</li><li>Hand Wash, Hang To Dry</li><li>Imported</li></ul>`,
            images:[
                {src: require('../assets/40000/40018 (1).webp')},
                {src: require('../assets/40000/40018 (2).webp')},
                {src: require('../assets/40000/40018 (3).webp')},
                {src: require('../assets/40000/40018 (4).webp')},
                {src: require('../assets/40000/40018 (5).webp')},
          
            ],
        },
        {
            id:40019,
            title:'Vegan Leather Embroidery Mini Skirt',
            amount:'72.99',
            originalAmount:'129.00',
            off:'43',
            colors:[{name:'black',src:require('../assets/color/black.webp')}],
            sizes:[{size:'XS'},{size:'S'},{size:'M'},{size:'L'},{size:'XL',},],
            sku:'7SKK0180BE',
            categories:'bottoms',
            categoryId:'40000',
            description:`Crafted with flower embroidery, five pockets, and silver hardware, this fitted vegan leather skirt is great for daytime outings or nighttime flair.`,
            key:`<ul><li>Fitted Silhouette</li><li> Stretch Fabric</li><li> Silver Color Hardware</li><li> Flower Embroidery Pattern</li><li> 5 Pockets</li><li> Front Fly Opening</li><li> 15 1/2" Skirt Length</li></ul>`,
            care:`<ul><li>100% Polyurethane;Lining: 90% Polyester, 10% Spandex</li><li>Hand Wash, Hang To Dry</li><li>Imported</li></ul>`,
            images:[
                {src: require('../assets/40000/40019 (1).webp')},
                {src: require('../assets/40000/40019 (2).webp')},
                {src: require('../assets/40000/40019 (3).webp')},
                {src: require('../assets/40000/40019 (4).webp')},
                {src: require('../assets/40000/40019 (5).webp')},
             
            ],
        },
        {
            id:40020,
            title:'Buckle Detail Mini Skirt',
            amount:'38.99',
            originalAmount:'119.00',
            off:'67',
            colors:[{name:'black',src:require('../assets/color/black.webp')}],
            sizes:[{size:'XS'},{size:'S'},{size:'M'},{size:'L'},{size:'XL',},],
            sku:'7SKK0178BE',
            categories:'bottoms',
            categoryId:'40000',
            description:`Buckle details bring an edge to this mini skirt; pair with your favorite tops for an eye-catching look.`,
            key:`<ul><li>Fitted Silhouette</li><li>Decorative Buckle</li><li>Mini Length</li><li>Pull-On Skirt</li><li>17" Dress Length</li></ul>`,
            care:`<ul><li>100% Polyurethane</li><li>Hand Wash, Hang To Dry</li><li>Imported</li></ul>`,
            images:[
                {src: require('../assets/40000/40020 (1).webp')},
                {src: require('../assets/40000/40020 (2).webp')},
                {src: require('../assets/40000/40020 (3).webp')},
                {src: require('../assets/40000/40020 (4).webp')},
                {src: require('../assets/40000/40020 (5).webp')},
            
            ],
        },
      
   
   

       
    ]
}
export default goods


// WEBPACK FOOTER //
// ./src/utils/goods.js